import * as React from "react";
import classnames from "classnames";
import { DataLayer } from "@grandvisionhq/analytics";
import { WizardProgress } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { isValidStepKey, bookAppointmentStepClickEvent } from "../../../../../data-layer/v3/data-layer/actions.js";
import { useAppointmentContext } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import { useDisableSteps } from "../../../hooks/v3/components/Navigation/hooks/use-disabled-steps.js";
import { mapStepToRoute, steps } from "./steps.js";
/* empty css                         */
import useVirtualAppointment from "../../../../../pages/BookAppointment/hooks/v3/pages/BookAppointment/hooks/use-virtual-appointment.js";
const NavigationContainer = ({ className, ...rest }) => {
  const { getLabel } = useIntl();
  const [{ goTo }, { queryParams, currentRoute }] = useRoutingContext();
  const [{ isVirtualAppointmentType }] = useVirtualAppointment();
  const [{ setStore, setType, setTimeSlot }, { store, type, timeSlot }] = useAppointmentContext();
  const labels = React.useMemo(
    () => [
      getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[0]}`),
      getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[1]}`),
      getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[2]}`),
      getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[3]}`)
    ],
    [getLabel]
  );
  const active = steps[currentRoute] ?? steps.where;
  const onStepClick = React.useCallback(
    (_, index) => {
      if (active === index) {
        return;
      }
      const targetRoute = mapStepToRoute[index];
      if (!targetRoute) return;
      const dataLayerSteps = {
        "": 1,
        where: 1,
        what: 2,
        when: 3,
        who: 4
      };
      if (isValidStepKey(currentRoute, dataLayerSteps) && isValidStepKey(targetRoute, dataLayerSteps)) {
        const dataLayerEvent = bookAppointmentStepClickEvent(
          {
            store: store && !isVirtualAppointmentType(type) ? {
              code: store.code,
              // TODO: MACC-19077
              globalStoreId: store.globalStoreId,
              streetName: store.streetName,
              town: store.town,
              name: store.name,
              postalCode: store.postalCode,
              streetNumber: store.streetNumber,
              additionalStreetInfo: store.additionalStreetInfo
            } : void 0,
            appointment: type ? {
              appointmentType: {
                id: type.id,
                ageGroup: type.ageGroup,
                isVirtualAppointment: isVirtualAppointmentType(type)
              },
              startTime: timeSlot?.from,
              endTime: timeSlot?.until
            } : void 0
          },
          dataLayerSteps,
          currentRoute,
          targetRoute
        );
        DataLayer.pushEvent(dataLayerEvent);
      }
      switch (index) {
        /** On Where route click remove all query params from url */
        case 0: {
          const { typeId, search, userLocation } = queryParams;
          setStore(null);
          setTimeSlot(null);
          goTo(targetRoute, { typeId, search, userLocation });
          return;
        }
        /** On What route click should keep only storeId parameter in url */
        case 1: {
          const { storeId, search, userLocation } = queryParams;
          setType(null);
          setTimeSlot(null);
          goTo(targetRoute, { storeId, search, userLocation });
          return;
        }
        /** On When route click remove start and end from query params */
        case 2: {
          const { start, end, ...restQueryParams } = queryParams;
          setTimeSlot(null);
          goTo(targetRoute, restQueryParams);
          return;
        }
        default: {
          goTo(targetRoute, queryParams);
          return;
        }
      }
    },
    [
      goTo,
      store,
      type,
      timeSlot,
      setType,
      setTimeSlot,
      setStore,
      isVirtualAppointmentType,
      currentRoute,
      active,
      queryParams
    ]
  );
  const disabledSteps = useDisableSteps(active, queryParams);
  const skippedSteps = React.useMemo(
    () => queryParams.typeId && active === steps.where ? [steps.what] : [],
    [queryParams, active]
  );
  return /* @__PURE__ */ React.createElement(
    WizardProgress,
    {
      ...rest,
      className: classnames("book-appointment-navigation", className),
      steps: labels,
      active,
      disableSteps: disabledSteps,
      onClick: onStepClick,
      skipSteps: skippedSteps
    }
  );
};
export {
  NavigationContainer as default
};
//# sourceMappingURL=NavigationContainer.js.map
